import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormikContext, ErrorMessage } from "formik";

const DynamicDatePicker = ({ fieldName, label }) => {
  const { values, setFieldValue, handleBlur, touched, errors } = useFormikContext();

  React.useEffect(() => {
    // Initialize the field with the current date if it is empty
    if (!values[fieldName]) {
      setFieldValue(fieldName, new Date());
    }
  }, [fieldName, setFieldValue, values]);

  if (!fieldName) return null;

  return (
    <div className="mb-0 w-100">
      <style>{`
        .custom-datepicker {
          background: rgba(255, 255, 255, 0.08) !important;
          border: 1.5px solid rgba(255, 255, 255, 0.25) !important;
          color: white !important;
          font-weight: 900 !important;
          font-size: 0.82rem !important;
          height: 34px !important;
          border-radius: 6px !important;
          padding: 0 10px !important;
          width: 100%;
          position: relative !important;
          z-index: 2000 !important;
        }
        .custom-datepicker::placeholder {
          color: rgba(255, 255, 255, 0.4) !important;
        }
      `}</style>
      <DatePicker
        id={fieldName}
        name={fieldName}
        className={`form-control custom-datepicker ${touched[fieldName] && errors[fieldName] ? 'is-invalid' : ''}`}
        selected={values[fieldName] ? new Date(values[fieldName]) : null}
        onChange={(date) => setFieldValue(fieldName, date)}
        onBlur={handleBlur}
        dateFormat="dd/MM/yyyy"
        placeholderText="SELECT DATE"
        autoComplete="off"
        portalId="root-portal"
        popperPlacement="bottom-start"
      />
      <ErrorMessage name={fieldName} component="div" className="invalid-feedback" />
    </div>
  );
};

export default DynamicDatePicker;
